import React from 'react'
import Spinner from './Spinner'
import './styles/spinner.css'

/**
 * Pantalla de carga inicial (fallback de Suspense / arranque de la app).
 */
export default function SpinnerLoader({ text = `Cargando...` }) {
  return (
    <div className="ball-spinner-screen">
      <Spinner size={84} />
      {text ? <span className="ball-spinner-screen__text">{text}</span> : null}
    </div>
  )
}
